import { FlightStageTimeline } from '@features/regional-overview/digital-traps/components/flight-stage-timeline';
import type { FlightPredictionRowWithExtras } from '@features/regional-overview/digital-traps/domain/flight-prediction.models';
import { DAILY_COUNTS_PREDICTIONS_TRAP_CARD } from '@features/regional-overview/digital-traps/domain/tests-id.constants';
import { DailyCountsCard } from '../daily-counts-card';

export interface DailyCountsPredictionsTrapCardProps {
  record: FlightPredictionRowWithExtras;
  dates: string[];
}

export const DailyCountsPredictionsTrapCard = ({ record, dates }: DailyCountsPredictionsTrapCardProps) => (
  <DailyCountsCard
    trapName={record.name}
    trapId={record.id}
    total={record.total}
    status={record.status}
    dataTestId={DAILY_COUNTS_PREDICTIONS_TRAP_CARD}>
    <FlightStageTimeline dates={dates} columnPredictions={record._columnPredictions} />
  </DailyCountsCard>
);
